import { GameConfig } from "../GameConfig/GameConfig.js";

export default class ParallaxLayer {
  constructor(image, speedModifier, gamespeed, canvasWidth, canvasHeight) {
    this.x = 0;
    this.y = 0;
    this.imageWidth = 2000;
    this.imageHeight = 1176;
    this.canvasWidth = canvasWidth;
    this.canvasHeight = canvasHeight;

    this.image = image;
    this.gamespeed = gamespeed;

    this.speedModifier = speedModifier;
    this.speed = gamespeed * this.speedModifier + 5;
  }

  update(gamespeed) {
    this.speed = gamespeed * this.speedModifier;
    if (this.x <= -this.imageWidth) {
      this.x = this.imageWidth + this.x - this.speed;
    }
    this.x = Math.floor(this.x - this.speed);
  }

  draw(ctx) {
    ctx.drawImage(
      this.image,
      this.x,
      this.y,
      this.imageWidth,
      this.canvasHeight,
    );
    ctx.drawImage(
      this.image,
      this.x + this.imageWidth,
      this.y,
      this.imageWidth,
      this.canvasHeight,
    );
  }
}

export function setupParallaxLayers() {
  const Layer1 = new Image();
  Layer1.src = "./assets/Parallax/Layer-1.png";

  const Layer2 = new Image();
  Layer2.src = "./assets/Parallax/Layer-2.png";

  const Layer3 = new Image();
  Layer3.src = "./assets/Parallax/Layer-3.png";

  const Layer4 = new Image();
  Layer4.src = "./assets/Parallax/Layer-4.png";

  const ParallaxLayer1 = new ParallaxLayer(
    Layer1,
    GameConfig.PARALLAX.LAYER_1_SPEED_MODIFIER,
    GameConfig.GAME_SPEED,
    GameConfig.PARALLAX.WIDTH,
    GameConfig.PARALLAX.HEIGHT,
  );
  const ParallaxLayer2 = new ParallaxLayer(
    Layer2,
    GameConfig.PARALLAX.LAYER_2_SPEED_MODIFIER,
    GameConfig.GAME_SPEED,
    GameConfig.PARALLAX.WIDTH,
    GameConfig.PARALLAX.HEIGHT,
  );
  const ParallaxLayer3 = new ParallaxLayer(
    Layer3,
    GameConfig.PARALLAX.LAYER_3_SPEED_MODIFIER,
    GameConfig.GAME_SPEED,
    GameConfig.PARALLAX.WIDTH,
    GameConfig.PARALLAX.HEIGHT,
  );
  const ParallaxLayer4 = new ParallaxLayer(
    Layer4,
    GameConfig.PARALLAX.LAYER_4_SPEED_MODIFIER,
    GameConfig.GAME_SPEED,
    GameConfig.PARALLAX.WIDTH,
    GameConfig.PARALLAX.HEIGHT,
  );
  // const ParallaxLayer5 = new ParallaxLayer(Layer5, 0.4, gamespeed, 2000, 1176);

  return [
    // ParallaxLayer5,
    ParallaxLayer4,
    ParallaxLayer3,
    ParallaxLayer2,
    ParallaxLayer1,
  ];
}
